export default __webpack_public_path__ + "d81e6fb2242ff033f8c2ac59f1d590d2.png";